/**
 * お知らせバーのフェードアウト機能
 * フッターに入ったらお知らせバーをふわっと消す
 */
export const noticeBarFade = () => {
  const noticeBar = document.querySelector('.m-notice-bar');
  const footer = document.querySelector('.m-footer');

  if (!noticeBar || !footer) {
    return;
  }

  // Intersection Observerのオプション
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1, // フッターが10%見えたら発火
  };

  // コールバック関数
  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // フッターが見えたらお知らせバーを非表示
        noticeBar.classList.add('is-hidden');
      } else {
        // フッターが見えなくなったらお知らせバーを表示
        noticeBar.classList.remove('is-hidden');
      }
    });
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(callback, options);

  // フッターを監視対象に設定
  observer.observe(footer);
};
